import useAppStore from "@/context/store";
import { getDeliveryDetail, getQingzhouConfig } from "@/services";
import reporter from "@/tracker/report/reporter";
import { getPage } from "@/tracker/shared/global";
import useLaunchBottomVisibility from "@/utils/hooks/useLaunchBottomVisibility";
import {
  SuspensionPanel,
  offTrackerClickEventListener,
  onTrackerClickEventListener,
} from "@gdesign/suspension-panel";
import "@gdesign/suspension-panel/style.css";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import { get } from "lodash";
import { useEffect, useState } from "react";
import { openUdesk } from "../../../utils/initUdesk";
import styles from "./index.module.less";

export default function SuspensionPanelComponent() {
  const { user } = useAppStore(({ user }) => ({ user }));
  const { launchBottomVisible } = useLaunchBottomVisibility();
  const [dataSource, setDataSource] = useState({
    pits: [],
    qrSocialCodeImg: "",
  });
  const getData = useMemoizedFn(async () => {
    const qingzhouConfigRes = await getQingzhouConfig({
      position: "framework-suspension-panel-huaban",
    });
    const deliveryDetailRes = await getDeliveryDetail("web-global-guide-sns");

    const feedback = get(
      qingzhouConfigRes,
      "pits[0].materials[0].material.feedback"
    );

    if (feedback) {
      const updatedFeedback = feedback.map((item) => {
        if (
          item.type === "link" &&
          item.link &&
          item.link.includes("support.qq.com")
        ) {
          const url = new URL(item.link);
          url.searchParams.set(
            "customInfo",
            user?.urlname ? `https://huaban.com/${user.urlname}` : ""
          );

          return {
            ...item,
            link: url.toString(),
          };
        }
        return item;
      });

      // 更新 qingzhouConfigRes 中的 feedback
      qingzhouConfigRes.pits[0].materials[0].material.feedback =
        updatedFeedback;
    }

    return {
      pits: qingzhouConfigRes?.pits || [],
      qrSocialCodeImg:
        deliveryDetailRes?.pit_modules?.[0]?.material?.search_img_url,
    };
  });
  useEffect(() => {
    let isMounted = true;
    getData().then((res) => {
      if (isMounted) {
        setDataSource(res);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [getData, user]);

  useEffect(() => {
    const trackerClickEventListener = (data) => {
      const pageName = getPage();
      const trackData = {
        event_id: 39008,
        event_name: "button_click",
        module_name: "右侧悬浮导航",
        subject_name: "按钮",
        button_name: data.detail.button_name,
        ...pageName,
      };
      reporter(trackData);
    };

    onTrackerClickEventListener(trackerClickEventListener);

    return () => {
      offTrackerClickEventListener(trackerClickEventListener);
    };
  }, []);

  return (
    <div
      className={classNames([
        styles.suspensionPanel,
        launchBottomVisible ? styles.launchBottomShow : null,
      ])}
    >
      <SuspensionPanel
        portal="huaban"
        dataSource={dataSource}
        onCustomerServiceClick={openUdesk}
      />
    </div>
  );
}
